// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"452":"d204f29c","468":"a22d07f7","592":"2ba2db34","700":"a9fa08e4","831":"88d09006"}[chunkId] + ".chunk.css";
};